import getLLMModel from 'common/src/modules/shared/copilot/models/utils/getLLMModel';
import {OpenAIModel} from 'common/src/modules/shared/copilot/openAI/openAI.enums';
import {OpenAIModelConfig} from 'common/src/modules/shared/copilot/openAI/openAI.models';

function getSetupAgentModel(): OpenAIModelConfig {
  const setupAgentModel = getLLMModel(OpenAIModel.Gpt5_2);

  return setupAgentModel;
}

export default getSetupAgentModel;
